import clsx from "clsx";
import { FC, memo, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { usePageContext, useRegisterSpecificTableRowId } from "@ryde/redux";
import {
  draggingKanbanRideIdSelector,
  IRideTableDto,
  isHighlightedAfterEditSF,
} from "@ryde/shared";

import { KanbanCardStyled } from "../../common";
import {
  KanbanItemPassengers,
  LineFooterDivider,
  RideKanbanItemCenter,
  RideKanbanItemFooter,
  RideKanbanItemHeader,
} from "../../kanban";

interface ICardBoardItemProps {
  rideDto: IRideTableDto;
}

export const CardBoardItem: FC<ICardBoardItemProps> = memo(({ rideDto }) => {
  const tempRideDragId = useRecoilValue(draggingKanbanRideIdSelector);
  const { entity } = usePageContext();
  useRegisterSpecificTableRowId(rideDto.id);

  const isDroppableState = useMemo(() => {
    return tempRideDragId === rideDto.id;
  }, [rideDto, tempRideDragId]);
  const isHighlightedAfterEdit = useRecoilValue(
    isHighlightedAfterEditSF([entity, rideDto.id]),
  );

  return (
    <KanbanCardStyled
      data-e2e-id={`ride_${rideDto.id}`}
      className={clsx("CardBoardItem", {
        waiting_drop: isDroppableState,
        kanban_item: true,
        after_edit_highlighted: isHighlightedAfterEdit,
      })}
    >
      <RideKanbanItemHeader dto={rideDto} />
      <RideKanbanItemCenter dto={rideDto} />

      <KanbanItemPassengers rideDto={rideDto} />
      <LineFooterDivider />
      <RideKanbanItemFooter dto={rideDto} />
    </KanbanCardStyled>
  );
});
